<template>
    <div class="heading">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="heading-container content-sm d-flex flex-md-row flex-column justify-content-md-between align-items-center">
                        <div class="text-md-left text-center order-md-1 order-2">
                            <p data-type="main-text">
                                Boost Your Campaign With The Power of the Crowdfunding Community
                            </p>
                            <p data-type="main-text" data-name="desc">
                                Crossprom brings together creators across the globe to build a strong crowdfunding community and help each other succeed. 
                            </p>
                            <Button id="join-community-heading-button" type="landing-btn" @click.native="checkAuthState" class="mx-md-0 mx-auto">
                                Join Community
                            </Button>
                        </div>
                        <div class="text-md-right text-center order-md-2 order-1">
                            <div class="image-overlay"/>
                            <img src="/img/landinghero.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import Button from '@/components/Theme/Button'
import useAuthCheck from './useAuthCheck'
export default {
    name: 'Heading',
    components: {
        Icon,
        Button
    },
   
    setup: function() {
        const { checkAuthState } = useAuthCheck('Landing Join Community Top')
        return {
            checkAuthState
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables.scss';

$title: $h2;
$desc: $p24;
$title_line_height: 52px;
$desc_line_height: 40px;
$btn_mob: $p3;
$mob_desc_line_height: 28px;
$mob_line_height: 31px;
$mob_title: $p1;
$mob_desc: $p3;
.heading {
    background: #F8F8FF;
    min-height: 100vh;
    height: 579px;
    display: flex;
    align-items: center;
    .heading-container {
        div {
            &:first-child {
                max-width: 560px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-top: 24px;
                p {
                    &:first-child {
                        font-family: 'EinaBold';
                        font-size: $title;
                        font-family: 'EinaBold';
                        line-height: $title_line_height;
                    }
                    &:nth-child(2){
                        margin-top: 16px;
                        font-size: $desc;
                        line-height: $desc_line_height;
                    }
                }
                button {
                    max-width: 285px;
                    padding: 24px 64px 24px 64px;
                    margin-top: 24px;
                }
            }
            &:nth-child(2) {
                div.image-overlay {
                    display: none;
                }
                img {
                    min-width: 300px;
                    height: 70vh;
                    object-fit: contain;
                }
            }
        }
    }
}
@media (max-width: 767px) {
.heading {
    min-height: 100vh;
    height: 624px;
    .heading-container {
        div {
            &:first-child {
                max-width: 560px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-top: 24px;

                p {
                    &:first-child {
                        font-size: $mob_title;
                        font-family: 'EinaBold';
                        line-height: $mob_line_height;
                    }
                    &:nth-child(2){
                        margin-top: 16px;
                        font-size: $mob_desc;
                        line-height: $mob_desc_line_height;
                    }
                }
                button {
                    max-width: 100% !important;
                    width: 100%;
                    padding: 24px 0 24px 0;
                    margin-top: 24px;
                    font-size: $btn_mob;
                }
            }
            &:nth-child(2) {
                position: relative;
                height: 327px;
                overflow: hidden;
                img {
                    min-width: 300px;
                }
                div.image-overlay {
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-image: linear-gradient(to top, white, 
                        rgba(248, 248, 255, 0.916), 
                        rgba(255, 255, 255, 0.484), 
                        rgba(255,255, 255, -0.2));
                    left: 0;
                    top: 0;
                }
            }
        }
    }
}
}
</style>